<template>
  <div class="w-full rounded overflow-hidden shadow-lg bg-gray-100">
    <nuxt-img
      v-if="testimonial.show_profile_img"
      class="w-full"
      :src="testimonial.profile_img_local"
      :alt="`${testimonial.name} profile photo`"
      format="webp"
      width="550"
      height="550"
    />
    <div class="p-8">
      <blockquote class="text-base italic text-gray-700">
        <svg
          class="w-8 h-8 text-gray-400 dark:text-gray-600 mb-4"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 18 14"
        >
          <path
            d="M6 0H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3H2a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Zm10 0h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3h-1a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Z"
          />
        </svg>
        <p>"{{ normalizedText }}"</p>
      </blockquote>
    </div>
    <div class="px-8 pt-4 pb-8 flex justify-between">
      <div class="inline-block text-4xl font-semibold text-gray-700 mr-2 mb-2">
        {{ testimonial.name }}
      </div>
      <div>
        <a :href="testimonial.link" target="_blank">
          <nuxt-img
            format="webp"
            width="40"
            height="40"
            src="/images/socials/facebook-blue.png"
            alt="Facebook"
          />
        </a>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { TestimonialItem } from "~/slices/testimonials/types.js";

type Props = {
  testimonial: TestimonialItem;
};

const props = withDefaults(defineProps<Props>(), {
  testimonial: {},
});

// Normalize line endings so SSR and client render the same (avoids hydration mismatch)
const normalizedText = computed(() =>
  (props.testimonial?.text ?? "").replace(/\r\n/g, "\n").replace(/\r/g, "\n"),
);
</script>
